"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileUploader;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _lodash = _interopRequireDefault(require("lodash"));
var _BsFileEarmarkArrowUp = require("@react-icons/all-files/bs/BsFileEarmarkArrowUp");
var _utils = require("./utils");
var S = _interopRequireWildcard(require("./styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function FileUploader({
  accept,
  description,
  disabled = false,
  error,
  hideDescription = false,
  hideTitle = false,
  maxFiles = 1,
  name,
  title,
  ...rest
}) {
  const [field, meta, helper] = (0, _formik.useField)(name);
  const inputRef = (0, _react.useRef)(null);
  const errorMessage = meta.touched && meta.error || error;
  const isValuedArray = _lodash.default.isArray(field.value) && !_lodash.default.isEmpty(field.value);
  const handleOnChange = e => {
    if (rest.onChange) {
      rest.onChange(e);
    }
    const uploadedFiles = isValuedArray ? [...e.target.files, ...field.value] : e.target.files;
    const mergedFiles = _lodash.default.chain(uploadedFiles).uniqBy('name').take(maxFiles).value();
    helper.setValue(mergedFiles);
    e.target.value = '';
  };
  const handleRemoveFile = fileName => {
    const files = _lodash.default.reject(field.value, ['name', fileName]);
    helper.setValue(files);
  };
  return /*#__PURE__*/_react.default.createElement(S.Wrapper, null, !hideTitle && /*#__PURE__*/_react.default.createElement(S.Title, null, title || `Select ${maxFiles > 1 ? 'files' : 'a file'} to upload:`), !hideDescription && /*#__PURE__*/_react.default.createElement(S.Description, null, description || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, accept && `Supported files: ${(0, _utils.getSupportedFilesFromAcceptProp)(accept)}\n`, `Max ${maxFiles} file${maxFiles > 1 ? 's' : ''}`)), /*#__PURE__*/_react.default.createElement(S.ButtonWrapper, null, /*#__PURE__*/_react.default.createElement(S.BrowseButton, {
    disabled: disabled,
    onClick: () => inputRef.current?.click()
  }, "Browse..."), !isValuedArray && `No file${maxFiles > 1 ? 's' : ''} selected.`), /*#__PURE__*/_react.default.createElement(S.HiddenInput, _extends({
    accept: accept,
    multiple: true
  }, field, rest, {
    id: name,
    ref: inputRef,
    type: "file",
    onChange: handleOnChange,
    value: ""
  })), isValuedArray && /*#__PURE__*/_react.default.createElement(S.FilesWrapper, {
    $disabled: disabled
  }, _lodash.default.map(field.value, file => /*#__PURE__*/_react.default.createElement(S.FilePreview, {
    key: file.name
  }, /*#__PURE__*/_react.default.createElement(_BsFileEarmarkArrowUp.BsFileEarmarkArrowUp, null), /*#__PURE__*/_react.default.createElement(S.FileName, {
    title: file.name
  }, file.name), /*#__PURE__*/_react.default.createElement(S.CloseButton, {
    onClick: () => handleRemoveFile(file.name)
  })))), !!errorMessage && /*#__PURE__*/_react.default.createElement(S.Error, null, errorMessage));
}